import FqApi from '@/services/fq-api'

const baseUrl = '/flexiquotemodule'

export default {
  async getAllPermissionRecords() {
    let url = `${baseUrl}/getAllPermissionRecords`
    const result = await FqApi.get(url)
    return result.data
  },
  async updatePermissionRecords(permissionRecords, moduleId) {
    let url = `${baseUrl}/updatePermissionRecords/${moduleId}`
    const result = await FqApi.put(url, permissionRecords)
    return result.data
  },
  async getFlexiquoteModules(filter) {
    let url = `${baseUrl}/list/`
    const result = await FqApi.post(url, filter)
    return result.data
  },
  async getEntity(id) {
    const rs = await FqApi.get(`${baseUrl}/${id}`)
    const data = rs.data
    return data
  },
  async getFlexiquoteModuleById(moduleId) {
    const result = await FqApi.get(`${baseUrl}/${moduleId}`)
    return result.data
  },
  async getNewEntity() {
    const result = await FqApi.get(`${baseUrl}/new`)
    return result.data
  },
  async postEntity(entity) {
    return FqApi.post(baseUrl, entity)
  },
  async putEntity(entity) {
    return FqApi.put(`${baseUrl}/${entity.flexiQuoteModuleId}`, entity)
  }
}

